import clsx from "clsx"
import { ComponentProps, PropsWithChildren } from "react"
import { tv } from "tailwind-variants"

const variants = tv({
  base: "flex justify-center items-center relative",
  variants: {
    variant: {
      large: "py-5",
      medium: "py-3",
      small: "py-2",
    },
    admin: {
      true: "bg-glass border border-dotted border-grey-dark flex justify-center items-center",
    },
  },
  defaultVariants: {
    variant: "medium",
    admin: false,
  },
})

type Props = ComponentProps<"div"> & {
  size?: keyof typeof variants.variants.variant
  noAdmin?: boolean
}

export function Divider(props: Props) {
  return (
    <div
      {...props}
      className={clsx(variants({ variant: props.size, admin: env.admin && !props.noAdmin }), props.className)}
    >
      <div className="border-b border-solid w-full" />
      {env.admin && !props.noAdmin && (
        <span className="text-grey-mid text-sm absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{`Divider ${props.size}`}</span>
      )}
    </div>
  )
}
